var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"locale"},[_c('b-img',{attrs:{"src":_vm.currentLocale.img,"height":"14px","width":"22px","alt":_vm.currentLocale.locale}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }